import React, { PureComponent } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import Loading from '../../../utils/animation/loading';
import { switchPage } from '../../../utils/api/pageControl';
import commonStore from '../../../store/commonStore.js';
import * as HTML_RENDITION from '../../../utils/general/general';
import $ from 'jquery';
import ModalPopup from '../../../modalrelated/modalPopup';
import NormalScreenPopup from '../../../modalrelated/normalScreenPopup';
import * as commonStateAction from '../../../actions/commonStateAction';
import * as deviceInfoService from '../../../utils/general/deviceInfoService';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import _, { isEmpty } from 'lodash';
import RenditionUrlGenerator from '../../../utils/api/renditionUrlGenerator';
import { getStaticEPFAccessToken } from '../../../utils/general/EpfTokensUtils';
import { addParam } from '../../../utils/general/general';

interface IBullBearProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    menuPaneStatus: string;
    htmlPDFtoggleStatus: boolean;
}

export class BullBear extends PureComponent<IBullBearProps, any> {
    public bullBearJumpId: any;
    public originDocUrl: any;

    constructor(props: IBullBearProps) {
        super(props);
        this.bullBearJumpId = '';
        this.originDocUrl = null;
        this.state = {
            modalStatus: false,
        };
    }

    public isShowOriginLinkFun() {
        const { docHeaderSectionJson } = this.props;
        return docHeaderSectionJson.bullBearChart.isOriginDoc == 'false';
    }

    public openOriginLinkHrefFun(e: any){
        e.preventDefault();
        let originDocUrlLink = this.originDocUrl;
        if (_.isEmpty(originDocUrlLink)) {
            originDocUrlLink = this.props.docHeaderSectionJson.bullBearChart.originDocUrl;
        }
        if (HTML_RENDITION.isBloomBerg()) {
            HTML_RENDITION.checkDocIdAndOpenPubicationForBBGWithDocumentURL(originDocUrlLink, true);
            return;
        }
        if (HTML_RENDITION.isThirdPartyTokenAuthorization()) {
            HTML_RENDITION.executeWindowOpenForEPFToken(originDocUrlLink);
            return;
        }

        window.open(originDocUrlLink, HTML_RENDITION.isAppInsideCVResearchUIiFrame() ? '_self' : '_blank');
    }

    public openBullBearChart(e:any) {
        RSCH_HTML_TRACKING_CONFIG.trackRequestBullBearClick();
        if (deviceInfoService.isDeviceScreenType()) {
            commonStore.dispatch(commonStateAction.menuPaneStatus(''));
            $('#rightPartContain').hide();
        }
        // Important!!! the close modal action can through bubbling propagation to here, So that we can set the status again!
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target.id === "modalClose" || e.target.className === 'bb_scrollToLink') { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            // this.getBullBearChart();
            this.setState({
                modalStatus: true,
            });
            e.target.className += " triggered_popup_flag";
        }
    }

    public getModalSource() {
        const { docHeaderSectionJson, initialData } = this.props;
        let bullBaerInnerDOM: any = null;
        let template: any = null;
        let _bullBearJumpId = '';
        this.bullBearJumpId = initialData.docFileType == "HTML" ? $('.bullBearPage .fg-content').attr('id') : $('.BullBearPage .BullBearPage').attr('id');
        _bullBearJumpId = this.bullBearJumpId;
        const bullBearImageLength = $('#' + _bullBearJumpId).find('img').length;
        let ifShowScrollToLink = false;

        if (_bullBearJumpId && initialData.docFileType != "HTML") {
            ifShowScrollToLink = true;
            if (bullBearImageLength == 1) {
                const BBImgs = $('#' + _bullBearJumpId).find('img');
                template = BBImgs[0].outerHTML;
                bullBaerInnerDOM = <div id="bull-bear-body" dangerouslySetInnerHTML={{ __html: template }} />;
            } else if (bullBearImageLength == 2) {
                const BBImgs = $('#' + _bullBearJumpId).find('img');
                template = BBImgs[0].outerHTML + BBImgs[1].outerHTML;
                bullBaerInnerDOM = <div id="bull-bear-body" dangerouslySetInnerHTML={{ __html: template }} />;
            } else {
                const bb_images = <div style={{paddingLeft: '13px'}}>The data structure or type has some issue, and can't render the Bull & Bear image now.</div>;
                bullBaerInnerDOM = <div id="bull-bear-body">{bb_images}</div>;
            }
        } else {
            ifShowScrollToLink = !!_bullBearJumpId;
            bullBaerInnerDOM =
            (<div id="bull-bear-body">
                <img role="img" className="bullbear-chart-img" src={docHeaderSectionJson.bullBearChart.chartUrl} alt={HTML_RENDITION.buildAdaAltText(docHeaderSectionJson.i18n.bullBearScenarios + '.', 'chart image.')} />
                <img role="img" className="bullbear-table-img" src={docHeaderSectionJson.bullBearChart.tableUrl} alt={HTML_RENDITION.buildAdaAltText(docHeaderSectionJson.i18n.bullBearScenarios + '.', 'table image.')} />
            </div>);
        }

        const bullBearOuterDOM =
            <div id="bull-bear-popup-content">
                {this.isShowOriginLinkFun() &&
                    <div className="bb_view_original_doc">
                        <a tabIndex={0} role="link"
                           onClick={(e) => this.openOriginLinkHrefFun(e)}
                           onKeyPress={(e) => enterKeyPressed(e, this.openOriginLinkHrefFun.bind(this))}
                           aria-label={docHeaderSectionJson.i18n.original_link}
                        >{docHeaderSectionJson.i18n.original_link}</a>
                    </div>
                }
                <div id="popup_bullbear">
                    {bullBaerInnerDOM}
                </div>
                <div className={"bb_scrollToLink_holder " + (ifShowScrollToLink ? 'show' : 'hide')}>
                    <span>{docHeaderSectionJson.i18n.figure_here_before} </span>
                    <a tabIndex={ifShowScrollToLink ? 0 : -1} role="link" className="bb_scrollToLink" onClick={(e) => this.scrollToCompBullBear(e, _bullBearJumpId)} aria-label={docHeaderSectionJson.i18n.figure_here}>{docHeaderSectionJson.i18n.figure_here} </a>
                    <span>{docHeaderSectionJson.i18n.figure_here_after}</span>
                </div>
            </div>;
        return bullBearOuterDOM;
    }

    public scrollToCompBullBear(e: any, bullBearJumpId: any) {
        // Important!!! Don't use react-redux mapStateToProps to get switchPageData in this file! Because when switchPageData change, it will cause reRender!
        const _pageName = commonStore.getState().commonStateReducer.switchPageData.pageName;
        if (_pageName !== 'mainPage') {
            switchPage('TocToMainPage');
        }
        if (this.props.initialData.showPDFDigidocViewer) {
            HTML_RENDITION.toggleToShowHTML(this.props.htmlPDFtoggleStatus);
        }
        HTML_RENDITION.bodyScrollTo(bullBearJumpId);
    }

    public render() {
        const { docHeaderSectionJson } = this.props;
        const _modalStatus = this.state.modalStatus;
        let _modalSource = null;

        if (docHeaderSectionJson.bullBearChart) {
            _modalSource = this.getModalSource();
        }
        // adding comapny23 bullbear popup url
        const isJP = docHeaderSectionJson.metadata.isJP;
        const environment = window.HTML_RENDITION.initialData.environment;
        const ticker = docHeaderSectionJson.metadata.ticker;
        let bullBearUrl =
          RenditionUrlGenerator.URL_GENERATOR.environments(environment) +
          `/directory/eppublic/company23/${ticker}/popup/bb?language=${isJP ? 'ja' : 'en'}`;        

        const epfToken =  getStaticEPFAccessToken();
        if (!isEmpty(epfToken)) {
            bullBearUrl = addParam(bullBearUrl, '__epftoken', epfToken);
        }

        return (
            <React.Fragment>
                <div className="bullBearChart financials" onClick={(e) => this.openBullBearChart(e)} onKeyPress={(e) => enterKeyPressed(e, this.openBullBearChart.bind(this, e))}>
                    {_modalStatus && _modalSource &&
                        (<ModalPopup classList={'modal-bullbear'}>
                            <NormalScreenPopup titleSource={`${docHeaderSectionJson.i18n.bullBearScenarios}: ${this.props.docHeaderSectionJson.metadata.companyNameAndTicker}`}
                                               bodySource={_modalSource}
                                               modalWindowStyle={{width:'100%',height: '100%'}}
                                               iframeUrl={bullBearUrl}
                                               isBullBear={true}
                            />
                        </ModalPopup>)}
                        {/* {showOldBranding && <span className="icon-bull-bear-chart icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.bullBearScenarios}/>} */}
                        <span className='icon-svg-parent'>
                            <span className="icon-svg icon-bull-bear-chart-svg" role="img" aria-label={docHeaderSectionJson.i18n.bullBearScenarios}/>
                        </span>
                        <a tabIndex={0} role="link" id="request-Bull-Bear" aria-label={docHeaderSectionJson.i18n.bullBearScenarios} className="x-rsch-hyperlink">{docHeaderSectionJson.i18n.bullBearScenarios}</a>
                </div>
                {_modalStatus && !_modalSource && window.HTML_RENDITION.initialData.showOldLoading &&
                    <Loading overrideStyle={{ position: 'fixed' }} showLoadingBackground={true} />}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        menuPaneStatus: state.commonStateReducer.menuPaneStatus,
        htmlPDFtoggleStatus: state.commonStateReducer.htmlPDFtoggleStatus,
    };
};

export default connect(mapStateToProps)(BullBear);
